//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BcCheckStatus from '@/components/common/BcCheckStatus'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'FreelancerFeedbackItem',
  components: {
    BcCheckStatus
  },
  props: {
    feedback: {
      type: Object,
      required: true
    }
  },
  computed: {
    createdAt () {
      return this.$moment(this.feedback.createdAt).format('D.M.YYYY HH:mm')
    }
  }
}
